const ReportGenerateIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1235 1.5L6.37353 1.5C5.75221 1.5 5.24854 2.00368 5.24854 2.625C5.24854 3.24632 5.75221 3.75 6.37353 3.75L10.1235 3.75C10.7449 3.75 11.2485 3.24632 11.2485 2.625C11.2485 2.00368 10.7449 1.5 10.1235 1.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.24854 11.25H7.81995M5.24854 8.25L11.2485 8.25"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2485 9.74963L14.2486 7.11197C14.2486 4.99068 14.2486 3.93003 13.5895 3.27103C13.1086 2.79005 12.4136 2.66011 11.2486 2.625M10.4985 16.4996H6.74853C4.62722 16.4996 3.56656 16.4996 2.90755 15.8406C2.24854 15.1816 2.24854 14.1209 2.24854 11.9996L2.24854 7.11202C2.24854 4.99069 2.24854 3.93003 2.90755 3.27102C3.38851 2.79005 4.08342 2.66011 5.24846 2.625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7485 14.25H13.4985M13.4985 14.25H11.2485M13.4985 14.25V16.5M13.4985 14.25V12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReportGenerateIcon;
